module.exports = __webpack_public_path__ + "img/011_schlegel.d71692fb.jpg";